import React from "react";
import { useNavigate } from "react-router-dom";
import { URLencode } from "../../../utils/url";
import { allStatuses } from "../OrderList";
import { isCustomerSite } from "../../../utils/getsubDomain";

export default function PackageMenu({
  order,
  mobile,
  setCancel,
  setPay,
  setDetail,
}) {
  const navigate = useNavigate();

  const isVisible = (type) => {
    switch (type) {
      case "View Booking":
        return allStatuses
          .filter(
            (status) =>
              ![
                "Pending",
                "Not Paid",
                "Pending",
                // "Paid",
                "Booked",
                "Failed",
              ].includes(status),
          )
          ?.includes(order?.status);
      case "Pay Booking":
        return ["Booked", "Pending", "Not Paid"]?.includes(order?.status);
      case "Update Fare":
        return (
          ["Booked", "Pending", "Not Paid"]?.includes(order?.status) &&
          !isCustomerSite()
        );
      case "Cancel Booking":
        return (
          allStatuses?.includes(order?.status) &&
          !["Cancelled"].includes(order?.status)
        );
      // return true;
      case "Send Invoice":
        return allStatuses?.includes(order?.status);
      case "Price Details":
        return allStatuses?.includes(order?.status);
      // case "Modify Reference":
      //   return allStatuses?.includes(order?.status);
      default:
        return false;
    }
  };

  const menu = [
    {
      label: "View Booking",
      action: () => {
        // let parameters = {
        //   id: order?._id,
        //   bookingId: order?._id,
        // };
        // navigate(`/protection/confirmation?${URLencode(parameters)}`);
        setDetail?.(true);
      },
      visible: isVisible("View Booking"),
    },
    {
      label: "Pay Booking",
      action: () => {
        setPay?.(true);
      },
      visible: isVisible("Pay Booking"),
    },
    // {
    //   label: "Update Fare",
    //   action: () => {
    //     setUpdateFareInsuranceOrder(true);
    //   },
    //   visible: isVisible("Update Fare"),
    // },
    {
      label: "Cancel Booking",
      action: () => {
        setCancel(true);
      },
      visible: isVisible("Cancel Booking"),
    },
    // {
    //   label: "Send Invoice",
    //   action: () => {
    //     setInsuranceInvoice(true);
    //   },
    //   visible: isVisible("Send Invoice"),
    // },
  ];

  return (
    <div
      className={`${
        !mobile ? "absolute right-2 top-full" : ""
      } p-2 flex flex-col z-10 bg-white rounded-md shadow-xl min-w-[200px]`}
    >
      {menu
        ?.filter((item) => item?.visible)
        ?.map((item, index) => (
          <div
            key={index}
            className="w-full cursor-pointer text-sm text-black py-1 px-2 transition-all hover:text-primary1"
            onClick={item.action}
          >
            <span>{item.label}</span>
          </div>
        ))}
    </div>
  );
}
